import VacationDaysParamsTable from './VacationDaysParamsTable';

export default VacationDaysParamsTable;
